import { theme } from '../theme'
import React, { useContext } from 'react'
import styled from 'styled-components'
import { FaCheck, FaExclamation, FaFlag } from 'react-icons/fa'
import { WatchContext } from '../WatchContext'

const Styles = {
   TableHeader: styled.span`
   font-size: 1.5rem;
   text-transform: uppercase;
   font-weight: bold;
   `,
   RowTitle: styled.span`
   font-weight: bold;
   padding: 0.5rem;
   line-height: ${({ lineHeight }) => lineHeight};
   color: ${({ theme }) => theme.colors.grey3};
   `,
   CellValue: styled.span`
   background-color: ${({ color }) => color || 'inherit'};
   padding: 0.5rem;
   `,
   WideDiv: styled.div`
   width: 95%;
   `,
   Table: styled.table`
   margin: 1rem;
   border: 1px solid black;
   border-collapse: collapse;
   th {
      text-transform: uppercase;
   }
   th, td {
     padding: 1.5rem;
     border: 1px solid black;
   }
   `,
}

const OutputSummaryTable = () => {

   const { horizontal, vertical, biology, hydrology } = useContext(WatchContext)

   let topicArray = [horizontal, vertical, biology, hydrology]

   let { redCell, yellowCell, greenCell, ruYellow, ruRed, pdeGreen } = theme.colors;

   return (
      <>
         <Styles.Table>
            <caption>Table 1: Output Summary</caption>
            <thead>
               <tr>
                  <th>Violations</th>
                  {topicArray.map((topic, i) => (
                     <th key={i}>
                        {topic.type}
                     </th>
                  ))}
               </tr>
            </thead>
            <tbody>
               <tr>
                  <td>Future</td>
                  {topicArray.map((topic, i) => (
                     <td key={i} style={{ textAlign: 'center', backgroundColor: topic.futureConcern === 1 ? redCell : topic.futureConcern === -1 ? yellowCell : greenCell }}>
                        {topic.futureConcern === 1 ? <FaFlag color={ruRed} /> : topic.futureConcern === -1 ? <FaExclamation color={ruYellow} /> : <FaCheck color={pdeGreen} />}
                     </td>
                  ))}
               </tr>
               <tr>
                  <td>Current</td>
                  {topicArray.map((topic, i) => (
                     <td key={i} style={{ textAlign: 'center', backgroundColor: topic.currentConcern === 1 ? redCell : topic.currentConcern === -1 ? yellowCell : greenCell }}>
                        {topic.currentConcern === 1 ? <FaFlag color={ruRed} /> : topic.currentConcern === -1 ? <FaExclamation color={ruYellow} /> : <FaCheck color={pdeGreen} />}
                     </td>
                  ))}
               </tr>

            </tbody>
         </Styles.Table>
         <div style={{ width: '100%', display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
            <span><FaFlag color={ruRed} /> deficiency detected</span>
            <span>               <FaExclamation color={ruYellow} /> need more info  </span>
            <span><FaCheck color={pdeGreen} /> meets user criteria</span>
         </div>
      </>
   )
}

export default OutputSummaryTable